export enum HiddenNavigationBarEnum {
  /**
   * 打开页面时，默认隐藏客户端 navbar
   */
  hiddenNavigationBar = '1',
}
